export const CART_STORAGE_KEY = 'maaliondoor.cart.v1'

export const CART_PATHS = {
  page: '/cart',
} as const

export const CART_ADD_INTENT = {
  add: 'add',
  buy: 'buy',
} as const

export type CartAddIntent = (typeof CART_ADD_INTENT)[keyof typeof CART_ADD_INTENT]

export const CART_UI = {
  emptyTitle: 'Your cart is empty',
  emptyHint: 'Browse the shop and add something you love.',
  continueShopping: 'Start shopping',
  remove: 'Remove',
  quantityLabel: 'Quantity',
  subtotalLabel: 'Total',
  savedLabel: 'You save',
  savedBanner: 'You have saved',
  billTitle: 'Bill summary',
  orderTotalLabel: 'Order total',
  grandTotalLabel: 'Grand total',
  couponNote:
    'Have a coupon code? You can apply the discount coupon during checkout.',
  addedFeedback: 'Added to cart',
  inCartFeedback: 'In your cart',
  viewCart: 'Go to cart',
  pageTitle: 'Cart',
  headerLabel: 'Cart',
  itemSingular: 'item',
  itemPlural: 'items',
  checkout: 'Proceed to checkout',
} as const


